<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{
        rowIndex + 1
      }}</span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plStatus' + _uid"
        :name="'plStatus' + _uid"
        :select2-options="plStatusOptions"
        @selectChange="onStatusChange"
        v-model="itemStatus"
        ref="plStatus"
        data-msg-required="กรุณาเลือกสถานะ"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plProductType' + _uid"
        :name="'plProductType' + _uid"
        :select2-options="plProductTypeOptions"
        @selectChange="onProductTypeChange"
        v-model="itemProductType"
        ref="plProductType"
        data-msg-required="กรุณาเลือกประเภทสินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plProductId' + _uid"
        :name="'plProductId' + _uid"
        :select2-options="plProductIdOptions"
        @selectChange="onProductChange"
        v-model="itemProductId"
        ref="plProductId"
        data-msg-required="กรุณาเลือกสินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>

    <td class="form-group text-center">
      <img style="cursor:pointer;" v-if="itemImage" v-bind:src="itemImage" width="100" @click="pictureModal(itemImage, rowIndex)">
      <div
        :id="'PictureModal' + rowIndex"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modelSingle"
      >
        <div class="modal-dialog modal-xl" role="document">
          <form class="kt-form">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">รูปภาพ</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body text-center">
                <img
                  v-if="modalImage"
                  class="img-thumbnail mb-3"
                  style="width:100%;"
                  v-bind:src="modalImage"
                  alt="Product Image"
                />
                <p v-else>ไม่พบรูปภาพ</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  <i class="la la-close"></i> ปิดหน้าต่าง
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </td>

    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plQuota' + _uid"
        :name="'plQuota' + _uid"
        :select2-options="plQuotaOptions"
        @selectChange="onQuotaChange"
        v-model="itemQuota"
        ref="plQuota"
        data-msg-required="กรุณาเลือกแบรนด์สินค้า"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        :disabled="!isEditable"
        type="number"
        class="form-control required text-right"
        min="0"
        placeholder="จำนวน"
        :id="'plQty' + _uid"
        :name="'plQty' + _uid"
        v-model="item.plQty"
        data-msg-required="กรุณากรอกจำนวน"
      />
      <span class="form-text">{{ CheckStockAnswer }}</span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plAgent' + _uid"
        :name="'plAgent' + _uid"
        :select2-options="plAgentOptions"
        v-model="itemAgent"
        @selectChange="onAgentChange"
        ref="plAgent"
        data-msg-required="กรุณาเลือกตัวแทนจำหน่าย"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <select2
        :disabled="!isEditable"
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'plShopActivityId' + _uid"
        :name="'plShopActivityId' + _uid"
        :select2-options="plShopIdOptions"
        @selectChange="onShopIdChange"
        v-model="itemShopActivityId"
        ref="plShopActivityId"
        data-msg-required="กรุณาเลือกร้านค้า/กิจกรรม"
      ></select2>
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <input
        :disabled="!isEditable"
        type="text"
        class="form-control"
        v-bind:class="{ required: requiredRemark }"
        placeholder="หมายเหตุ"
        :id="'Remark' + _uid"
        :name="'Remark' + _uid"
        v-model="item.plActivityRemark"
        data-msg-required="กรุณากรอกหมายเหตุ"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">
      <div class="input-group date">
        <input
          :disabled="!isEditable"
          readonly
          type="text"
          class="form-control"
          v-bind:class="{ required: requiredDate }"
          :id="'plReturnDate' + _uid"
          :name="'plReturnDate' + _uid"
          @click="onReturnDateClick"
          placeholder="วันคืนสินค้า"
          ref="plReturnDate"
          data-msg-required="กรุณาเลือกวันคืนสินค้า"
        />
        <span class="form-text"></span>
        <div class="input-group-append">
          <span class="input-group-text">
            <i class="la la-calendar-check-o"></i>
          </span>
        </div>
      </div>
    </td>
    <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
          v-if="isEditable"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td>
  </tr>
</template>

<script>
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";
import router from "../../router";
import Swal from "sweetalert2";
import axios from "axios";
import lodash from "lodash";

export default {
  components: {
    select2,
    datepicker,
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    var self = this;

    return {
      CheckStockAnswer: "",
      itemStatus: null,
      itemQty: 0,
      itemProductId: null,
      itemImage: null,
      modalImage: null,
      itemProductType: null,
      itemQuota: null,
      itemAgent: null,
      itemShopActivityId: null,
      requiredRemark: false,
      requiredDate: false,
      plStatusOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          //url: "/Api/Variables/Options",
          url: "/Api/Variables/ProductLoanItemStatusOptions",
          data: function(params) {
            var query = {
              search: "PRODUCT_LOAN_ITEM_STATUS",
              page: params.page || 1,
              isAgent:
                self.$parent.cbpIsAgent !== undefined
                  ? self.$parent.cbpIsAgent
                  : self.$parent.ubpIsAgent,
              productGroupCode:
                self.$parent.cbpProductGroupCode !== undefined
                  ? self.$parent.cbpProductGroupCode
                  : self.$parent.ubpProductGroup,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      plProductIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              productTypeId:
                self.item.plProductType != null ? self.item.plProductType : "",
              productGroupId:
                self.$parent.cbpProductGroupId !== undefined
                  ? self.$parent.cbpProductGroupId
                  : self.$parent.ubpProductGroupId,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      plProductTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/ProductType/Select2ProductTypeByGroup",
          data: function(params) {
            var query = {
              search: params.term,
              productGroupId:
                self.$parent.cbpProductGroupId !== undefined
                  ? self.$parent.cbpProductGroupId
                  : self.$parent.ubpProductGroupId,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      plQuotaOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Quota/Select2Quota",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      plShopIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/ProductLoan/Select2ShopActivity",
          data: function(params) {
            var query = {
              userId:
                self.$parent.cbpBorrower !== undefined
                  ? self.$parent.cbpBorrower
                  : self.$parent.ubpBorrower,
              agentCode: self.item.plAgent != null ? self.item.plAgent : 0,
              isAgent:
                self.$parent.cbpIsAgent !== undefined
                  ? self.$parent.cbpIsAgent
                  : self.$parent.ubpIsAgent,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },

          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      plAgentOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: false,
        ajax: {
          url: "/Api/ProductLoan/Select2SearchAgent",
          data: function(params) {
            var agent = null;
            if (self.$parent.cbpIsAgent !== undefined) {
              if (self.$parent.cbpIsAgent) {
                agent = self.$parent.cbpAgentCode;
              }
            } else {
              if (self.$parent.ubpIsAgent) {
                agent = self.$parent.ubpAgentCode;
              }
            }

            var query = {
              userId:
                self.$parent.cbpBorrower !== undefined
                  ? self.$parent.cbpBorrower
                  : self.$parent.ubpBorrower,
              agentCode: agent,
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },

          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },

  methods: {
    // getStock: function() {
    //   var vm = this;
    //   vm.CheckStockAnswer = "";
    //   if (this.item.plQty > this.item.plAvailableQty) {
    //     vm.CheckStockAnswer =
    //       "จำนวน Stock ไม่เพียงพอ ระบุได้ไม่เกิน " +
    //       this.item.plAvailableQty +
    //       " ชิ้น";

    //     this.item.plQty = this.item.plAvailableQty;
    //   }

    //   return false;
    // },
    onRemoveItemClick(e) {
      var self = this;
      self.$emit("removeItem", self.rowIndex, self.item);
    },
    onStatusChange: function(id, text, data, ref) {
      var self = this;
      self.item.plStatus = self.itemStatus;
      self.requiredDate = false;

      if (data.length != 0) {
        if (data[0].text == "ยืม") {
          self.requiredDate = true;
        }

        //Set selectedStatusCodeData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        self.item.selectedStatusCodeData = {
          id: data[0].id,
          text: data[0].text,
        };
      }
    },
    onProductTypeChange: function(id, text, data, ref) {
      var self = this;
      self.item.plProductType = self.itemProductType;

      if (self.$parent.isChange) {
        $("#" + self.$refs.plProductId.id)
          .val("")
          .trigger("change");

        //Set selectedProductTypeData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        if (data.length != 0) {
          self.item.selectedProductTypeData = {
            id: data[0].id,
            text: data[0].text,
          };
        }
      } else {
        self.$parent.isChange = true;
      }
    },
    onQuotaChange: function(id, text, data, ref) {
      var self = this;
      self.item.plQuota = self.itemQuota;
      //Set selectedQuotaData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
      if (data.length != 0) {
        self.item.selectedQuotaData = {
          id: data[0].id,
          text: data[0].text,
        };
      }
    },
    onProductChange: function(id, text, data, ref) {
      // console.log("onProductChange");
      // console.log(id, text, data, ref)

      if (data.length === 0) {
        return false;
      }

      var self = this;
      self.item.plProductId = self.itemProductId;
      // if (self.$parent.isChange) {
        self.item.plProductId = self.itemProductId;
        self.item.plAvailableQty = data[0].data.availableQTY;
        self.item.plProductType = data[0].data.productTypeId;

        /*============ Check Stock ============*/
        // if (data[0].data.availableQTY === 0) {
        //   self.item.plProductId = null;
        //   $("#" + self.$refs.plProductId.id)
        //     .val("")
        //     .trigger("change");

        //   Swal.fire({
        //     title: "เกิดข้อผิดพลาด",
        //     html:
        //       "ไม่สามารถเลือก " +
        //       data[0].text +
        //       " เนื่องจากไม่มีในสต๊อก <strong> ",
        //     type: "warning"
        //   });

        //   return false;
        // }
        /*============ Check Price ============*/
        if (data[0].data.avgPrice == 0 && data[0].data.initialPrice == 0) {
          // console.log("123");
          self.item.plAvgPrice = 0;
          self.item.plInitialPrice = 0;

          //Call Api Recheck Price
          axios
            .get("/Api/Product/Select2Product", {
              params: {
                search: self.item.plProductId,
                productTypeId:
                  self.item.plProductType != null
                    ? self.item.plProductType
                    : "",
                productGroupId:
                  self.$parent.ubpProductGroupId !== null
                    ? self.$parent.ubpProductGroupId
                    : "",
                page: 1,
              },
            })
            .then(function(response) {
              if (response.status == 200) {
                if (
                  response.data.results != null &&
                  response.data.results.length > 0
                ) {
                  self.item.plAvgPrice = response.data.results[0].data.avgPrice;
                  self.item.plInitialPrice =
                    response.data.results[0].data.initialPrice;

                  if (self.item.plInitialPrice == 0) {
                    if (self.$root.canShow(["MANAGE_PRODUCT"])) {
                      Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        html:
                          "ไม่สามารถเลือก " +
                          data[0].text +
                          " เนื่องจากไม่มีราคาสินค้า <strong> ",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "เพิ่มข้อมูลราคาสินค้า",
                      }).then((result) => {
                        if (result.value) {
                          let routeData = self.$router.resolve({
                            path: "/Master/Product/Update/" + data[0].id,
                          });
                          window.open(routeData.href, "_blank");
                        }
                      });
                    } else {
                      Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        html:
                          "ไม่สามารถเลือก " +
                          data[0].text +
                          " เนื่องจากไม่มีราคาสินค้า <strong> กรุณาติดต่อ Admin",
                        type: "warning",
                      });
                    }

                    //Set Unselect
                    self.item.plProductId = null;
                    self.itemProductId = null;
                    $("#" + self.$refs.plProductId.id)
                      .val("")
                      .trigger("change");
                  }
                }
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  "ไม่สามารถดึงข้อมูลสินค้าได้ในขณะนี้",
                  "warning"
                );
              }
            });
        } else {
          // console.log("456");
          // if (self.$parent.isChange) {
            self.$parent.isChange = false;

            self.item.plAvgPrice = data[0].data.avgPrice;
            self.item.plInitialPrice = data[0].data.initialPrice;

            self.$refs.plProductType.setSelectedData({
              id: data[0].data.productTypeId,
              text: data[0].data.productTypeName,
            });

            self.item.selectedProductTypeData = {
              id: data[0].data.productTypeId,
              text: data[0].data.productTypeName,
            };

            //Set selectedProductData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
            self.item.selectedProductData = {
              id: data[0].id,
              text: data[0].text,
              data: data[0].data,
            };

            setTimeout(function() {
              self.$parent.isChange = true;
            }, 50);
          // }
        }
        // set image 
        let imgDownload = null;
        if (data && data[0] && data[0].data && data[0].data.picture) {
          imgDownload = data[0].data.picture;
        }
        if (imgDownload) {
          let fileUrl = imgDownload.fileInfoId
          axios
            .get("/Api/File/FileDownload", {
              params: {
                FileInfoId: fileUrl
              }
            })
            .then(function(response) {
              if (response.status === 200 && response.data.success) {
                self.itemImage = response.data.fileUrl;
              }
              else {
                self.itemImage = false;
              }
            })
            .catch(error => {
              self.itemImage = false;
            });
        }
        else {
          self.itemImage = false;
        }
        // set image
      // }
    },
    onShopIdChange: function(id, text, data, ref) {
      var self = this;

      if (data.length === 0) {
        return false;
      } else {
        if (self.$parent.isChange) {
          self.item.plShopActivityId = self.itemShopActivityId;

          self.item.selectedActivityData = self.item.selectedShopData;
          this.requiredRemark = false;
          self.item.plIsShop = false;
          self.item.plShopId = null;
          self.item.plActivityId = null;

          //Check Shop Or Activity
          if (text == "0") {
            self.item.plShopActivityId = self.itemShopActivityId = null;
          }

          if (data[0].data != null) {
            if (data[0].data.shop) {
              self.item.plShopActivityId = self.itemShopActivityId = self.item.plShopId = text;
              self.item.plIsShop = true;
              //Set selectedShopData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
              self.item.selectedShopData = {
                id: data[0].id,
                text: data[0].text,
              };
            }
            if (!data[0].data.shop) {
              self.item.plShopActivityId = self.itemShopActivityId = self.item.plActivityId = text;
              this.requiredRemark = true;
              //Set selectedActivityData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
              self.item.selectedActivityData = {
                id: data[0].id,
                text: data[0].text,
              };
            }
          }
        }
      }
    },
    onAgentChange: function(id, text, data, ref) {
      var self = this;
      if (self.$parent.isChange) {
        self.item.plAgent = self.itemAgent;

        //Clear Shop or Activity Select2
        $("#" + self.$refs.plShopActivityId.id)
          .val("")
          .trigger("change");

        //Set selectedAgentData ใช้ตอน Event "onRemoveItemClick" เพื่อ set Select2
        if (data.length != 0) {
          self.item.selectedAgentData = {
            id: data[0].id,
            text: data[0].text,
          };
        }
      }
    },
    onReturnDateClick() {
      let self = this;
      let plReturnDate = self.item.plReturnDate;
      if (plReturnDate != null) {
        let reqDate =
          self.$parent.cbpReqDate !== undefined
            ? self.$parent.cbpReqDate
            : self.$parent.ubpReqDate;
        let today = moment();
        let startDate = reqDate < plReturnDate ? reqDate : plReturnDate;
        startDate = today < startDate ? today : startDate;
        $(self.$refs.plReturnDate).datepicker(
          "setStartDate",
          startDate.format("DD/MM/YYYY")
        );
      } else {
        $(self.$refs.plReturnDate).datepicker(
          "setStartDate",
          moment().format("DD/MM/YYYY")
        );
      }
    },
    pictureModal(fileUrl, rowIndex) {
      let self = this;
      self.modalImage = null;
      if (fileUrl) {
        self.modalImage = fileUrl;
        const modalId = `#PictureModal${rowIndex}`;
        $(modalId).modal("show");
      } else {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิกลิงก์ที่ถูกต้อง", "error");
      }
    },
  },

  mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.plReturnDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //startDate: moment().format("DD/MM/YYYY"), // Current day
      //endDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });

    $(self.$refs.plReturnDate)
      //.datepicker("update", self.item.plReturnDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        e.date != undefined
          ? (self.item.plReturnDate = moment(e.date))
          : (self.item.plReturnDate = null);
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Borrow/ProductLoanItemRow.vue